import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
    };

    return axios.get(`${url}/activities`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    console.log(id);
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activities/${id}?include=category,skills`, options)
        .then(response => {
            let activity = jsona.deserialize(response.data);
            delete activity.links;
            return activity;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/activities/${id}?include=category`, options)
        .then(response => {
            let activity = jsona.deserialize(response.data);
            delete activity.links;
            return activity;
        });
}

function add (activity) {
    const payload = jsona.serialize({
        stuff: activity,
        includeNames: ['categories']
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/activities?include=category`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (activity) {
    const payload = jsona.serialize({
        stuff: activity,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/activities/${activity.id}?include=category`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/activities/${id}`, options);
}
function detachSkill(activityId, skillId) {

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
        data: {
            data: [
                {
                    type: "skills",
                    id: skillId
                }
            ]
        }
    };

    return axios.delete(
        `${url}/activities/${activityId}/relationships/skills`,
        options
    );
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy,
    detachSkill
};

